import axios from "axios";

const PREFIJO = "/api/Frmlr/"

export default {
    tipoInteresado(){
        const dto = {
            dt4: process.env.VUE_APP_TIPO_INTERESADO
        }
        return axios.post(`${PREFIJO}VmSlInrRl`,dto);
    }
}